import React from 'react';
import classnames from 'classnames';
import styles from './style.less';

export interface ImageLoadProps {
  className?: string;
  style?: React.CSSProperties;
  source?: string;
}

interface ImageLoadState {
  loaded: boolean;
}

class ImageLoad extends React.Component<ImageLoadProps, ImageLoadState> {

  constructor(props: ImageLoadProps) {
    super(props);
    this.state = {
      loaded: false
    }
  }

  onImageLoad = () => {
    this.setState({
      loaded: true
    });
  }

  render() {
    const { source, style, className } = this.props;
    const { loaded } = this.state;
    return (
      <div className={classnames(styles.imageLoad, className)} style={style}>
        <img
          src={source}
          onLoad={this.onImageLoad}
          style={{ opacity: loaded ? 1 : 0 }}
        />
        <i className={classnames(styles.ripple, {
          [styles.rippleHide]: loaded
        })}></i>
      </div>
    )
  }
}

export default ImageLoad;
